export const getMdSize = (value: number) => {
  return (value / 1300) * 100;
};
